import { render, staticRenderFns } from "./StaffMember.vue?vue&type=template&id=63137c70&scoped=true"
import script from "./StaffMember.vue?vue&type=script&lang=js"
export * from "./StaffMember.vue?vue&type=script&lang=js"
import style0 from "./StaffMember.vue?vue&type=style&index=0&id=63137c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63137c70",
  null
  
)

export default component.exports